<template>
  <div class="pageBottom">
    <div class="btm-content">
      <ul v-for="(item, index) in tipList" :key="index">
        <li class="btm-li">
          <span
            style="
              width: 2px;
              height: 17px;
              background-color: #fff;
              display: block;
              margin-right: 20px;
            "
          ></span>

          <span>
            {{ item.projectTypeName }}
          </span>
        </li>
        <li
          class="btm-li2"
          v-for="(item2, index2) in item.children"
          :key="index2"
          @click="tipItemClick(index, item, index2)"
        >
          {{ item2.projectTypeName }}
        </li>
      </ul>

      <div class="left">
        <img src="../assets/images/20240625160417.jpg" alt="" />
        <span>86-27-86964298</span>
        <div>武汉市武大园路光谷物联港</div>
      </div>
    </div>
    <div class="btm-end">
      Copyright &copy; 娲石水泥集团有限公司 版权所有 All Rights Reserved.
      鄂ICP备14002674号-4
    </div>
  </div>
</template>

<script>
import { getTAboutUsInfo, getTProjectTypeListByIndex } from "@/api/api.js";

export default {
  name: "pageBottom",
  data() {
    return {
      info: {},
      tipList: [],
      tipIndex: 0,
    };
  },
  created() {
    this.getTipList();
  },
  methods: {
    async getInfo() {
      const { data } = await getTAboutUsInfo();
      this.info = data.data;
    },
    async getTipList() {
      const { data } = await getTProjectTypeListByIndex();
      if (data.code === 200) { 
        this.tipList = data.data.splice(1, 5); 
      }
    },
    tipItemClick(index, row, index2) {
      this.tipIndex = index;
      if (index === 0) {
        this.$router.push({
          name: "news",
          query: { topIndex: index + 1 },
        });
      }
      if (index === 1) {
        this.$router.push({
          name: "exhibition",
          query: { topIndex: index + 1 },
        });
      }
      if (index === 2) {
        this.$router.push({
          name: "news3",
          query: { topIndex: index + 1 },
        });
      }
      if (index === 3) {
        this.$router.push({
          name: "news4",
          query: { topIndex: index + 1 },
        });
      }
      if (index === 4) {
        this.$router.push({
          name: "news5",
          query: { topIndex: index + 1 },
        });
      }
      if (index === 5) {
        this.$router.push({
          name: "news6",
          query: { topIndex: index + 1 },
        });
      }
      if (index === 6) {
        this.$router.push({
          name: "exhibition",
          query: { topIndex: index + 1 },
        });
      }

      this.$emit("bannerIndex", index2);
      localStorage.setItem("bannerList", JSON.stringify(row.children));
      localStorage.setItem("lobannerIndex", index2);
    },

    async jumpPage(row, index) {
      this.tipIndex = index;

      // const { data } = await getTProjectTypeListByIndex();
      if (index == 0) {
        this.$router.push({
          name: "news",
          query: { topIndex: 1 },
        });
      }
      if (index == 1) {
        this.$router.push({
          name: "news2",
          query: { topIndex: 2 },
        });
      }
      if (index == 2) {
        this.$router.push({
          name: "news3",
          query: { topIndex: 3 },
        });
      }
      if (index == 3) {
        this.$router.push({
          name: "news4",
          query: { topIndex: 4 },
        });
      }
      if (index == 4) {
        this.$router.push({
          name: "news5",
          query: { topIndex: 5 },
        });
      }
      if (index == 5) {
        this.$router.push({
          name: "news6",
          query: { topIndex: 6 },
        });
      }

      this.$emit("bannerIndex", index);

      localStorage.setItem("bannerList", JSON.stringify(row.children));
    },
  },
};
</script>
<style scoped lang="less">
.pageBottom {
  width: 100%;
  background: #2d303f;

  .btm-content {
    width: 86%;
    max-width: 1440px;
    height: 400px;
    margin: 0 auto;
    padding: 90px 0 30px 6%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    color: #ffffff;
    font-size: 16px;

    .btm-li {
      width: 120px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
    }
    .btm-li2 {
      text-align: left;
      width: 140px;
      padding-left: 35px;
      box-sizing: border-box;
      font-family: PingFang SC;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      margin: 16px 0;
    }
  }
  .left {
    width: 20%;
    text-align: right;

    img {
      width: 135px;
      height: 135px;
    }
    span {
      display: block;

      font-family: PingFang SC;
      font-size: 20px;
      color: #ffffff;
      line-height: 38px;
      padding-left: 30px;
      margin-top: 10px;
      text-align: right;
    }

    div {
      font-family: PingFang SC;
      font-size: 14px;
      color: #ffffff;
      line-height: 38px;
      margin-top: 10px;
      text-align: right;
    }
  }
}

.btm-end {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: rgba(31, 47, 75, 0.8);
  font-family: PingFang SC;
  font-size: 12px;
  color: #ffffff;
}

@media only screen and (max-width: 1500px) {
  .qr-code {
    margin-left: -3% !important;
  }
}
</style>
